import { render, staticRenderFns } from "./Initializer.vue?vue&type=template&id=0e9408b4&"
import script from "./Initializer.vue?vue&type=script&lang=js&"
export * from "./Initializer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports